import { Shield } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

export default function LoadingSpinner({ size = 'md', message }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center">
      <div className="relative">
        <div className="absolute inset-0 bg-blue-500 blur-xl opacity-50 animate-pulse"></div>
        <Shield className={`${sizeClasses[size]} text-blue-400 relative z-10 animate-pulse`} />
      </div>
      {message && (
        <p className="mt-4 text-gray-400 text-sm animate-pulse">{message}</p>
      )}
    </div>
  );
}
